import formatByCountry from "./FormatByCountry";
import { MY_CURRENCY_DISPLAY_PREFIX, configPrice } from "./modules/Price";

const formatPriceRP = (
  price: number,
  currency: "IDR" | "MYR" = "IDR"
): string => {
  const country = currency === "MYR" ? "MY" : "ID";
  const prefix =
    currency === "MYR"
      ? MY_CURRENCY_DISPLAY_PREFIX
      : configPrice.IDR?.prefix ?? "Rp";

  return `${prefix}${formatByCountry(price, { type: "money", country })}`;
};
export default formatPriceRP;
